/* TODO: t() */
import React from 'react';
import { StyleProp, TextStyle, View } from 'react-native';
import { RadioGroup, RadioItem, Text } from '..';

function BooleanInput(props: {
  value: boolean | undefined;
  label?: string;
  labelStyle?: StyleSet;
  onChange: (value: boolean) => void;
  trueParams?: { label: string; style?: StyleProp<TextStyle> };
  falseParams?: { label: string; style?: StyleProp<TextStyle> };
  style?: StyleSet;
  buttonStyle?: boolean;
}) {
  let {
    value,
    onChange,
    trueParams,
    falseParams,
    style,
    label,
    labelStyle,
  } = props;
  return (
    <RadioGroup
      selectedValue={value}
      onChange={(value) => onChange(value as boolean)}
      style={style}
    >
      <Text style={labelStyle}>{label ?? ''}</Text>
      <View style={{ flexDirection: 'row' }}>
        <RadioItem
          value={true}
          title={trueParams?.label ?? 'Yes'}
          textStyle={trueParams?.style}
        />
        <RadioItem
          value={false}
          title={falseParams?.label ?? 'No'}
          textStyle={falseParams?.style}
        />
      </View>
    </RadioGroup>
  );
}

export default BooleanInput;
